module.exports = __webpack_public_path__ + "static/media/icons8-heroku.aa5dd6d8.svg";